import React from 'react';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';

import { SyncMeetingsSteps } from '../../types';

import './CreateTeammatesWorkspacesFormFields.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  currentStep: SyncMeetingsSteps;
};

function CreateTeammatesWorkspacesFormFields({ currentStep }: Props) {
  const { tr } = useTranslation();

  return (
    <div className="CreateTeammatesWorkspacesFormFields d-flex flex-column">
      {currentStep === SyncMeetingsSteps.createNewTeammateWorkspaces && (
        <div>{tr('perform.sync_meetings.teammates.header_create', '1:1s')}</div>
      )}
      {currentStep === SyncMeetingsSteps.newOneOnOneMeetings && (
        <div>{tr('perform.sync_meetings.teammates.header_new_11', '1:1s')}</div>
      )}
      <div className="CreateTeammatesWorkspacesFormFields__highlight-description mt-3 mb-4">
        {tr('perform.sync_meetings.teammates.highlight_description')}
      </div>
      <FormRecurringMeetingsSelection
        selector="recurringMeetings"
        type={WorkspaceType.isTeammate}
        label={tr('perform.sync_meetings.teammates.label_calendar_11')}
      />
    </div>
  );
}

export default CreateTeammatesWorkspacesFormFields;
